import { createAsyncThunk } from "@reduxjs/toolkit";
import { CustomAction } from "../../store/customAction";
import { Api } from "../../";
import {
  IAgentTasksRequestBody,
  IAgentTasksResponseBody,
} from "../../models/agent/policiesListing";
import { API_GET_AGENT_TASKS, API_POST_DELETE_TASK } from "../../Apis/ApiEndPoints";

// Interface for delete task response
export interface IAgentDeleteTaskResponse {
  status: string;
  message: string;
}

export const GetAgentTasks = createAsyncThunk(
  "agent/get-tasks",
  async (requestBody: IAgentTasksRequestBody, { dispatch }) => {
    const response: IAgentTasksResponseBody = await CustomAction(
      Api.get(`${API_GET_AGENT_TASKS}/${requestBody.providerId}`),
      dispatch,
      "agent/get-tasks"
    );
    return response;
  }
);

export const GetAgentCustomerTasks = createAsyncThunk(
  "agent/get-customer-tasks",
  async (requestBody: any, { dispatch }) => {
    const response: IAgentTasksResponseBody = await CustomAction(
      Api.get(`${API_GET_AGENT_TASKS}/${requestBody.providerId}/${requestBody.customerId}`),
      dispatch,
      "agent/get-customer-tasks"
    );
    return response;
  }
);

export const DeleteAgentTask = createAsyncThunk(
  "agent/delete-task",
  async (taskId: string, { dispatch }) => {
    const response: IAgentDeleteTaskResponse = await CustomAction(
      Api.delete(`${API_POST_DELETE_TASK}/${taskId}`),
      dispatch,
      "agent/delete-task"
    );
    return response;
  }
);
